{
  "familyId": "SPR-KLANK-BAKKER",
  "questions": [
    {
      "id": "SPR-KLANK-BAKKER-001",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "Wat is het meervoud van 'auto'?",
      "context": null,
      "options": ["auto's", "autos", "autoos", "auto'en"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Meervoud na klinker", "content": "Eindigt een woord op een klinker (a, e, i, o, u)? Dan schrijf je het meervoud met een apostrof: auto → auto's, foto → foto's.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "plural_apostrophe_vowel",
      "variantIndex": 1,
      "feedback": { "explanationText": "Woorden die eindigen op een klinker krijgen een apostrof in het meervoud: auto → auto's. Dit voorkomt dat je drie klinkers achter elkaar krijgt (autooos).", "distractorExplanations": { "0": "Correct! Bij woorden op een klinker gebruik je een apostrof: auto's.", "1": "Fout: 'autos' zou je uitspreken als 'au-tos'. Je hebt een apostrof nodig: auto's.", "2": "Fout: drie o's achter elkaar is niet leesbaar. Gebruik een apostrof: auto's.", "3": "Fout: je gebruikt 's, niet 'en. Het meervoud is auto's." } }
    },
    {
      "id": "SPR-KLANK-BAKKER-002",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "fill_in",
      "question": "Maak een verkleinwoord van 'boom'.",
      "context": null,
      "options": ["boompje"],
      "correctAnswer": "boompje",
      "data": {
        "acceptableAnswers": ["boompje"],
        "placeholder": "Typ het verkleinwoord...",
        "caseSensitive": false
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "syllableBlocks", "data": { "word": "boompje", "syllables": ["boom", "pje"], "types": ["closed", "closed"], "label": "Verkleinwoord" }, "showWhen": "wrong" }, { "type": "rule", "data": { "title": "Verkleinwoord na lange klank", "content": "Boom heeft een lange 'oo'. Bij een verkleinwoord blijft deze dubbele klinker staan: boom → boompje (niet bompje).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "diminutive_pje",
      "variantIndex": 1,
      "feedback": { "explanationText": "Het verkleinwoord van 'boom' is 'boompje'. De dubbele 'oo' blijft staan omdat het een lange klank is. Je schrijft niet 'bompje' (dat zou een korte 'o' zijn)." }
    }
  ]
}